import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Pagination } from "../models/Pagination";

@Component({
    selector: 'pagination',
    templateUrl: 'pagination.component.html',
    styleUrls: ['pagination.component.css']
})
export class PaginationComponent {

    @Input() pagination!: Pagination;
    @Output() pageChange = new EventEmitter<number>();

    constructor() { }

    pageChangeRequest(page: number) {
        this.pageChange.emit(page);
    }

    range(start: number, end: number) {
      const length = end - start + 1;
      return Array.from({ length }, (_, i) => start + i);
    }

    get showPages() {
        return this.pagination.totalPages > 1;
    }
}